import { User } from 'firebase/auth'
import { createContext } from 'react'

export interface PrivateContext {
    user: User
}

const privateContext = createContext<PrivateContext | undefined>(undefined)

export default privateContext